import { Component, effect, inject, input } from '@angular/core';
import { BaseConfigurableComponent } from '@app/base-config.component';
import { ModalService } from '@app/services/modal/modal.service';
import { SchedulerStepService } from '@app/services/step/scheduler-step.service';

@Component({
  selector: 'afcu-branch',
  standalone: true,
  imports: [],
  providers: [ModalService],
  templateUrl: './branch.component.html',
  styleUrl: './branch.component.css'
})
export class BranchComponent extends BaseConfigurableComponent{
  protected schedulerService = inject( SchedulerStepService );
  trackByOrder = (index: number, item: { order: number }) => item.order;

  branchService = input.required<Branch>()
  target = input.required<string>()

  constructor( private modalService: ModalService) {
    super('page')
    effect(() => {
      this.schedulerService.getLastIncomplete()
    })
  }

  get phoneNumber(): string {
    const cleanPhone = ('' + this.branchService().phoneNumber).replace(/\D/g, '')
    const match = cleanPhone.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      var intlCode = (match[1] ? '+1 ' : '');
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return this.branchService().phoneNumber;
  }

  get steps() {
    // this.schedulerService.getLastIncomplete()
    return this.schedulerService.steps()
  }

  get activeStep(): number {
    return this.schedulerService.actualStep()
  }

  stepSelected(mapping: string) {

    const step = this.schedulerService.payload()[mapping]

    if (step)
      if(typeof step === 'string')
        return step
      else if(typeof step === 'object')
        return step.fullName

  }

  goTo(external:boolean): void {
    if (external){
      this.modalService.openModal('https://www.additionfi.com/locations', 'navigation')
    }else{
      this.modalService.openModal('/locations', 'navigation')
    }
    
  }
 
}
